import { LowStockIcon } from '@jouzen/ecom-components/icons/LowStockIcon';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { useAddOnBundleContext } from '@/app/[locale]/meta/_contexts/AddOnBundleProvider';

const ReachedThreeRingLimit = () => {
  const t = useTranslations();
  const { reachedThreeRingLimit } = useAddOnBundleContext();
  return (
    <div
      className={cx(
        'flex flex-row items-center pt-10 text-red-600',
        reachedThreeRingLimit ? 'block' : 'hidden',
      )}
      data-cy="reached-three-ring-limit"
    >
      <LowStockIcon height={20} width={20} />
      <Typography className="ml-3" color="error">
        {t('add_ons_3_ring_limit')}
      </Typography>
    </div>
  );
};
export default ReachedThreeRingLimit;
